import React from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroBanner from "../components/dual-program/HeroBanner";
import CourseTerms from "../components/dual-program/CourseTerms";
import CourseCards from "../components/CourseCards";
import CoursePolicies from "../components/CoursePolicies";
import Certification from "../components/Certification";
import Testimonials from "../components/Testimonials";
import MiniFaq from "../components/MiniFaq";

export default function DualProgram() {
    return (
        <>
            <Header />

            <HeroBanner />

            <CourseTerms />

            <CourseCards />

            <CoursePolicies />

            <Certification />

            <Testimonials />

            <MiniFaq />

            <Footer />
        </>
    );
} 